export default __webpack_public_path__ + "static/media/PPI-steps-010.01e1f1a6.jpg";